const storenumRexExp = new RegExp("(\\d)+");

export const isAllowedToSetStore = (
  buCode: string,
  allowedStores: string[]
): boolean => {
  const res = storenumRexExp.exec(buCode);
  return allowedStores?.includes(res?.[0] ?? buCode) || false;
};
